var _style, _circle, _circle2, _text, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymmetricDiffImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 200",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st1{fill:none;stroke:#231f20;stroke-miterlimit:10}")), /*#__PURE__*/React.createElement("path", {
    d: "M115 100c0-25.91 14.08-48.51 35-60.61A69.667 69.667 0 0 0 115 30c-38.66 0-70 31.34-70 70s31.34 70 70 70c12.75 0 24.7-3.43 35-9.39-20.92-12.1-35-34.7-35-60.61zm70-70c-12.75 0-24.7 3.43-35 9.39 20.92 12.1 35 34.71 35 60.61s-14.08 48.51-35 60.61a69.667 69.667 0 0 0 35 9.39c38.66 0 70-31.34 70-70s-31.34-70-70-70z",
    style: {
      fill: "#39cac4"
    }
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 115,
    cy: 100,
    r: 70
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 185,
    cy: 100,
    r: 70
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "translate(99.37 50.4)"
  }, "A")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(190.014 50.4)"
  }, "B")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymmetricDiffImg);
export default __webpack_public_path__ + "static/media/symmetricDiffImg.3c5e7d52fa0cc8e20df868821099b318.svg";
export { ForwardRef as ReactComponent };